import type { RouterConfig } from './router';
import { ComingSoonPage } from './pages/ComingSoonPage';

/**
 * Application routes configuration
 */
export const routerConfig: RouterConfig = {
  routes: [
    {
      path: '/',
      component: ComingSoonPage,
      title: 'Coming Soon - djjeck.com',
      description: 'Temporary holding page for djjeck.com while the website is being prepared.',
    },
    {
      path: '/coming-soon',
      component: ComingSoonPage,
      title: 'Coming Soon - djjeck.com',
      description: 'Temporary holding page for djjeck.com while the website is being prepared.',
    },
  ],
  fallback: '/coming-soon',
  // Animation hooks can be added here later
  // beforeNavigate: async (context) => {
  //   // Run exit animations
  //   await fadeOut();
  // },
  // afterNavigate: async (context) => {
  //   // Run enter animations
  //   await fadeIn();
  // },
};
